import chatBubbleFadeIn from '../../components/chat-conversations';

const chatBubbles = document.querySelectorAll('.plarium-play__chat-conversation__message__bubble');

window.addEventListener('DOMContentLoaded', () => {
  chatBubbleFadeIn(chatBubbles);
});
